// extracted by mini-css-extract-plugin
export default {"mainContainer":"sizeSlider_mainContainer__ssxow","sliderBox":"sizeSlider_sliderBox__oLBmT"};